// extracted by mini-css-extract-plugin
var _1 = "EntityMultiValue-moduleEntityMultiValue__Q43vu";
var _2 = "EntityMultiValue-moduletextContainer___6gE8";
export { _1 as "EntityMultiValue", _2 as "textContainer" }
